import { render, staticRenderFns } from "./VariablesExplanation.vue?vue&type=template&id=53ed689a&scoped=true&"
import script from "./VariablesExplanation.vue?vue&type=script&lang=js&"
export * from "./VariablesExplanation.vue?vue&type=script&lang=js&"
import style0 from "./VariablesExplanation.vue?vue&type=style&index=0&id=53ed689a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed689a",
  null
  
)

export default component.exports